"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyDriver = void 0;
function makeEmptyDriver() {
    return {
        age: 0,
        birthday: '',
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        gender: '',
        civilStatus: '',
        transitZone: '',
        transitTime: '',
        foulsQty: '',
        nationality: '',
        alcoholicBreath: '',
    };
}
exports.makeEmptyDriver = makeEmptyDriver;
//# sourceMappingURL=Driver.js.map